import React from "react";

// The public URL of your video
const VIDEO_URL = "https://ddmwrl2uut5q8.cloudfront.net/eqera.mp4";

const Video = () => {
  return (
    // You can apply styling to the container or directly to the video
    <div style={{ width: "100%", height: "100vh", position: "relative" }}>
      <video
        src={VIDEO_URL}
        autoPlay // Tells the browser to start playing as soon as it can
        loop // Will restart the video when it ends
        muted // **Crucial for autoplay in modern browsers**
        playsInline // Important for iOS to prevent fullscreen
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover", // Fills the container, cropping if necessary
        }}
      />
    </div>
  );
};

export default Video;